import React, { Component } from 'react'
import { Switch } from 'react-router-dom'
import { authRoutes } from '@routes'
import { renderRoutes } from '@helpers/routes'

class BasePage extends Component {
  render () {
    return (
      <div className='scope-auth-base'>
        <Switch>
          {renderRoutes(authRoutes)}
        </Switch>
      </div>
    )
  }
}

export default BasePage
